import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  subscriptionMessage: {
    width: '100%',
  },
  subscriptionField: {
    marginTop: '12px !important',
  },
});
